export const DRAWER_WIDTH = 260;
export const DRAWER_MINI = 72;
